// Schutz gegen Open Redirect auf dem Login-Pfad.
//
// Login, Passkey-Login und MFA-Verifikation übernehmen ihr Sprungziel aus dem
// Query-Parameter `redirectURL` — also aus einer Quelle, die der Angreifer
// vollständig kontrolliert (`/login?redirectURL=…`). Ohne Prüfung landet der
// User nach einem echten Login auf einer fremden Seite, was sich hervorragend
// für Phishing eignet.
//
// React Router bringt zwar eigene Schutzlogik mit, die aber schon einmal
// umgangen wurde (GHSA-wrjc-x8rr-h8h6, Backslash-Variante, gefixt in 7.18.0).
// Deshalb prüfen wir zusätzlich selbst, statt uns allein auf die Bibliothek zu
// verlassen.
//
// Erlaubt ist ausschliesslich ein interner, absoluter Pfad wie `/dashboard`
// oder `/l/abc?x=1`.

const DEFAULT_FALLBACK = '/dashboard';

export const safeRedirectPath = (value, fallback = DEFAULT_FALLBACK) => {
  if (typeof value !== 'string') return fallback;

  const path = value.trim();

  // Muss ein absoluter Pfad sein — schliesst `https://evil.com`,
  // `javascript:…` und relative Angaben aus.
  if (!path.startsWith('/')) return fallback;

  // `//evil.com` ist eine protokoll-relative URL und führt nach aussen.
  // Browser normalisieren `\` zu `/`, deshalb ist `/\evil.com` genauso
  // gefährlich — und Backslashes kommen in unseren Routen ohnehin nicht vor.
  if (/^\/[/\\]/.test(path)) return fallback;
  if (path.includes('\\')) return fallback;

  // Steuerzeichen könnten die Prüfungen oben unterlaufen, weil Browser sie
  // beim Auflösen der URL verwerfen (z. B. "/\t/evil.com").
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001F\u007F]/.test(path)) return fallback;

  return path;
};

export const COMPANY_DESIGNS_PATH = '/dashboard/firma/kartendesigns';
// Firmenbereich des Dashboards und die Firmenverwaltung des Plattform-Admins
// (dessen Firmenbestellung springt ebenfalls in den Designer und zurück).
const COMPANY_RETURN_PREFIXES = ['/dashboard/firma/', '/dashboard/firmenverwaltung/'];

// Rücksprung aus dem Designer im Firmenmodus (`returnTo` in der URL, also
// ebenfalls Angreifer-kontrolliert): nur in diese Bereiche des Dashboards.
// `..` könnte die Präfix-Prüfung über die Pfadauflösung wieder verlassen.
export const safeCompanyReturnTo = (value) => {
  const path = safeRedirectPath(value, COMPANY_DESIGNS_PATH);
  if (
    !COMPANY_RETURN_PREFIXES.some((prefix) => path.startsWith(prefix)) ||
    path.includes('..')
  ) {
    return COMPANY_DESIGNS_PATH;
  }
  return path;
};
